import { useState, useEffect } from 'preact/hooks';

import Home from '../routes/home';
import { getPageState } from "../common/api";
import { getToken } from "../common/helpers";
import styles from "./styles.css";

const App = () => {
  const [state, setState] = useState({ loading: true });

  useEffect(async () => {
    if (window.pageState) {
      setState(window.pageState);
    } else {
      const token = getToken();
      if (!token) {
        console.error("no token provided");
        return;
      }

      const result = await getPageState(token);
      setState(result);
    }
  }, []);


  if (state.loading) {
    return <div></div>;
  }

  if (state.code === "notfound") {
    return <EpistleMessage message={"We're sorry but we couldn't find what you're looking for 😔"}/>
  }

  if (state.code === "expired") {
    return <EpistleMessage message={"We're sorry but this link is expired 😔"}/>
  }

  if (state.code === "shared") {
    return <EpistleMessage message={"For security, this link has been locked because of an attempted share."}/>
  }

  if (state.code === "quota") {
    return <EpistleMessage
      message={"For security, this link has been locked because it has been viewed too many times."}/>
  }

  if (state.code === "noposts") {
    return <EpistleMessage
      message={"We're sorry but these updates have been deleted 😔"}/>
  }

  function addCommentToPost(postId, comment) {
    const post = state.posts.find((p) => p.id === postId);
    if (!post) return;

    if (!post.comments) post.comments = [];

    post.comments.push({
      ...comment,
      user: {
        id: state.user.id,
        _id: state.user.id,
        name: state.user.name,
      }
    });

    setState({
      ...state, posts: state.posts.map((p) => p.id === postId ? post : p)
    });
  }

  return (
    <div id="app">
      <main>
        <Home path="/" state={state} addCommentToPost={addCommentToPost}/>
      </main>
    </div>
  );
};

function EpistleMessage({ message }) {
  return <div id={styles.loading}>
    <img id={styles.logo} alt="" src={"https://assetbuilds.epistle.org/digest/assets/images/logo-v2.png"}/>
    <p id={styles.label}>{message}</p>
  </div>;
}

export default App;
